import React from 'react';
import { TemplateValues } from '@particular.cloud/i18n-js';
import useText from './useText';

export interface TextProps {
    // we cannot use the word "key" since it is reserved by React for managing lists
    textKey: string;
    language?: string;
    values?: TemplateValues;
    isolate?: boolean;
}

/**
 * Text: A component wrapper around the useT hook
 * (useful in class components where hooks cannot be used.)
 */
const Text: React.FC<TextProps> = ({ textKey, language, values, isolate }) => {
    if (!textKey) {
        throw Error(
            'Particular.Cloud: i18n-react Text component called without property "textKey". Make sure to pass a "textKey" to your Text component. Did you maybe use the React attribute key instead?',
        );
    }
    return <>{useText({ key: textKey, language, values, isolate })}</>;
};

export default Text;
